import React, {useState} from 'react';
import {Button, message, Modal, Select} from 'antd';
import {HttpService} from "../../services/http/Http.service";
import {ArchiveRequest, SimulatorPersonIdPair} from "../../model/models";
import {HttpErrorService} from "../../services/http/HttpError.service";

interface ArchiveProps {
    title?: string;
    selectedSimulatorPersonPairs: SimulatorPersonIdPair[];
    selectedFileTsIds: number[];
    onSuccess: () => void;
}

const Archive: React.FC<ArchiveProps> = ({title, selectedFileTsIds, selectedSimulatorPersonPairs, onSuccess}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const listOfOption =
        [
            {value: 'DECEDUTO', label: 'Deceduto'},
            {value: 'DECEDUTO_SENZA_EREDI', label: 'Deceduto senza eredi'},
            {value: 'IRREPERIBILE', label: 'Irreperibile'},
            {value: 'IMPORTO_ANTIECONOMICO', label: 'Importo antieconomico'},
        ]

    const [selectedArchiveLabel, setSelectedArchiveLabel] = useState<string>("")

    const openModal = () => {
        if (selectedSimulatorPersonPairs.length > 0 || selectedFileTsIds.length > 0) {
            setIsModalOpen(true);
        } else {
            message.error("Nessun utente selezionato.");
        }
    };

    const handleConfirm = async () => {
        try {
            const body:ArchiveRequest = {
                fileTsIds: selectedFileTsIds,
                simulatorPersonIdPairs: selectedSimulatorPersonPairs,
                reason: selectedArchiveLabel
            }
            await HttpService.getInstanceAxios().post(`/file-ts/archive`, body);

            message.success("Pratiche archiviate con successo");
            setIsModalOpen(false);
            onSuccess();
        } catch (error) {
            HttpErrorService.handle("Errore durante l'archiviazione delle pratiche", error, true)
        }
    };

    return (
        <>
            <Button className="custom-label-color"
                    onClick={openModal}
                    size={"large"}
                    disabled={selectedSimulatorPersonPairs.length === 0 && selectedFileTsIds.length === 0}
                    type={"primary"}>
                {title ?? 'Archivia'}
            </Button>
            <Modal
                title={"Archiviazione pratica"}
                open={isModalOpen}
                onOk={handleConfirm}
                onCancel={() => setIsModalOpen(false)}
                okText={"Sì, applica"}
                cancelText="Annulla"
            >
                <p>{"Per quale motivo vuoi archiviare la/le pratica/e?"}</p>
                <Select
                    style={{width: 200}}
                    allowClear
                    options={listOfOption}
                    dropdownStyle={{minWidth: 200, whiteSpace: 'nowrap'}}
                    onChange={(value) => setSelectedArchiveLabel(value)}
                />
            </Modal>
        </>
    );
};

export default Archive;
